import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiState } from "../../apis";
import { ApiMonitorHistory } from "../../apis/monitor-history";


const _sliceName = 'homeHistory';

const HomeHistorySlice = createSlice({
    name: 'homeHistory',
    initialState: {},
    reducers: {
        setLoading: (state, action) => {
            const { homeId, key } = action.payload;
            if (!state[homeId]) {
                state[homeId] = {};
            }
            if (!state[homeId][key]) {
                state[homeId][key] = undefined;
            }
            const subState = ApiState.fromOb(state[homeId][key]);
            state[homeId][key] = subState.toLoading().toOb();
        },
        setSuccess: (state, action) => {
            const { homeId, key, data } = action.payload;
            if (!state[homeId]) {
                state[homeId] = {};
            }
            if (!state[homeId][key]) {
                state[homeId][key] = undefined;
            }
            const subState = ApiState.fromOb(state[homeId][key])
            state[homeId][key] = subState.toComplete(data).toOb();
        },
        setError: (state, action) => {
            const { homeId, key, error } = action.payload;
            if (!state[homeId]) {
                state[homeId] = {};
            }
            if (!state[homeId][key]) {
                state[homeId][key] = undefined;
            }
            const subState = ApiState.fromOb(state[homeId]);
            state[homeId][key] = subState.toError(error).toOb();
        },
    }

})


const ApiThunkMonitorHistory = createAsyncThunk(
    `${_sliceName}/refresh`,
    (params, thunkApi) => {

        const state = thunkApi.getState();
        const { homeId, startDate, endDate, key } = params;
        const respectCache = endDate < (new Date()).toISOString();
        const apiState = state.homeHistory[homeId]?.[key];
        const hasData = apiState?.data?.time && Array.isArray(apiState?.data.time);
        const isLoading = apiState?.isLoading === true;

        if (isLoading === true) {
            return;
        }

        if (respectCache === true && hasData === true) {
            return;
        }

        try {

            thunkApi.dispatch(HomeHistorySlice.actions.setLoading({ homeId, key }));
            ApiMonitorHistory.summary({
                homeId,
                start: startDate,
                end: endDate,
            }).then((recordMap) => {
                thunkApi.dispatch(HomeHistorySlice.actions.setSuccess({
                    homeId,
                    key,
                    data: recordMap,
                }));
            }).catch((err) => {
                thunkApi.dispatch(HomeHistorySlice.actions.setError({
                    homeId,
                    key,
                    error: `${err}`
                }));
            });

        } catch (err) {
            thunkApi.dispatch(HomeHistorySlice.actions.setError({
                homeId,
                key,
                error: `${err}`
            }));
        }
    }
)




// class AppChartPoint {

//     constructor({
//         temperature,
//         humidity,
//         co2,
//         voc,
//         dust,
//         label,
//         group,
//         sortKey,
//     } = {}) {
//         this.temperature = temperature;
//         this.humidity = humidity;
//         this.co2 = co2;
//         this.voc = voc;
//         this.dust = dust;
//         this.temperatureLevel = this.getLevel(this.temperature, "TEMPERATURE");
//         this.humidityLevel = this.getLevel(this.humidity, "HUMIDITY");
//         this.co2Level = this.getLevel(this.co2, "CO2");
//         this.vocLevel = this.getLevel(this.voc, "VOC");
//         this.dustLevel = this.getLevel(this.dustLevel, "DUST");
//         this.label = label;
//         this.group = group;
//         this.sortKey = sortKey;
//     }


//     toJSON() {
//         return {
//             "temperature": this.temperature,
//             "humidity": this.humidity,
//             "co2": this.co2,
//             "voc": this.voc,
//             "dust": this.dust,
//             "temperatureLevel": this.temperatureLevel,
//             "humidityLevel": this.humidityLevel,
//             "co2Level": this.co2Level,
//             "vocLevel": this.vocLevel,
//             "dustLevel": this.dustLevel,
//             "label": this.label,
//             "group": this.group,
//             "sortKey": this.sortKey,
//         };
//     }

//     getLevel(value, type) {
//         return SensorOutputUtility.classify(value, type);
//     }


//     static fromList({
//         list,
//         label,
//         group,
//         sortKey,
//     }) {
//         let co2 = 0;
//         let humidity = 0;
//         let voc = 0;
//         let dust = 0;
//         let temperature = 0;
//         let total = 0;
//         list.forEach((item) => {
//             let averageReading = item.averageReading;
//             if (averageReading) {
//                 co2 += averageReading.co2;
//                 humidity += averageReading.humi;
//                 voc += averageReading.voc;
//                 dust += averageReading.pm25;
//                 temperature += averageReading.temp;
//             }
//             total += item.totalReading;
//         });
//         if (total > 0) {
//             co2 = co2 / total;
//             humidity = humidity / total;
//             voc = voc / total;
//             dust = dust / total;
//             temperature = temperature / total;
//         }
//         return new AppChartPoint({
//             temperature: temperature,
//             humidity: humidity,
//             co2: co2,
//             dust: dust,
//             voc: voc,
//             group: group,
//             label: label,
//             sortKey: sortKey,
//         });
//     }

//     value(type) {
//         if (type === 'temperature') {
//             return this.temperature;
//         }
//         if (type === 'humidity') {
//             return this.humidity;
//         }
//         if (type === 'co2') {
//             return this.co2;
//         }
//         if (type === 'voc') {
//             return this.voc;
//         }
//         if (type === 'dust') {
//             return this.dust;
//         }
//         return 0;
//     }

//     levelColor(type) {
//         if (type === 'temperature') {
//             return this.temperatureLevel;
//         }
//         if (type === 'humidity') {
//             return this.humidityLevel;
//         }
//         if (type === 'co2') {
//             return this.co2Level;
//         }
//         if (type === 'voc') {
//             return this.vocLevel;
//         }
//         if (type === 'dust') {
//             return this.dustLevel;
//         }
//         return this.dustLevel;
//     }

//     toWeekGroup() {
//         let date = this.toLocal();
//         if (date.getMinutes() <= 30) {
//             date.setMinutes(0);
//         } else {
//             date.setMinutes(30);
//         }
//         date.setSeconds(0);
//         date.setMilliseconds(0);
//         return date.toISOString();
//     }

//     toLocal() {
//         return new Date(this.sortKey);
//     }
// }



export { HomeHistorySlice, ApiThunkMonitorHistory };